<template>
    <div ref="tutto" class="cnt_complete">
        
        <div class="cnt_left" ref="cnt_left">
             <div class="immagine_right" ref="immagine"  :style="{'background-image': `url(${leftSrc})` }" @click="vaiASinistra" >
                 <div class="cnt_sotto_titolo">
                     <div class="sotto_titolo_relative" >
                        <div class="sotto_titolo"  ref="sotto_titolo_left" v-html="leftTitle"> 
                        </div>
                    </div>
                 </div>
                

                <div ref="left_slot" class="left_slot"> 
                    <div class="cnt_text">
                        <div class="go-to-double"><span>Torna indietro</span><i class="material-icons">navigate_next</i></div>
                        <div class="text"> 
                            <div>
                                <slot name="left"> </slot> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        
        <div class="cnt_right" ref="cnt_right">
             <div class="immagine" ref="immagine" :style="{'background-image': `url(${rightSrc})` }" @click="vaiADestra">
                <div class="cnt_sotto_titolo">
                    <div class="sotto_titolo_relative" >
                        <div class="sotto_titolo" ref="sotto_titolo_right">
                            {{rightTitle}}
                        </div>
                    </div>
                 </div>

                <div ref="right_slot" class="right_slot">
                    <div class="cnt_text" id="text_right">
                        <div class="go-to-double"> <i class="material-icons">navigate_before</i><span>Torna indietro</span></div>
                        <div class="text" id="text_right">
                            <div>
                                <slot name="right" > </slot> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="back-to-clock" :class="{
            'hidden':page!='center'
        }"><router-link to="/orologio/"> Torna all'orologio</router-link><br><div class="underline"></div></div>

    </div>    
</template>

<script>
import  {TimelineMax, TweenMax} from "gsap"; 

export default {
    name: 'double-page',
    props: {
        'leftTitle': {
            type: String,
            default: ''
        },
        'rightTitle': {
            type: String,
            default: ''
        },
        
        'leftSrc': {
            type: String,
            default: ''
        },
        
        'rightSrc': {
            type: String,
            default: ''
        },
    }, 
    data() {
        return {
            page: 'center',
            iterato:false 
        }
    }, 
    methods: { 
        permetti(){
            this.iterato=false;
        },
        onNavigateTo(ev) { 
              console.log("ciao", this);
            
        },
        vaiASinistra(ev) {
            if(this.page == "sx" && ev.clientX < window.innerWidth/2) return;  
            if(this.iterato==true) return;

            else{
            this.iterato=true;
            let tl=new TimelineMax({});
            switch(this.page) {
                case "center":
                    this.page = "sx"
                    console.log(this.iterato);

                    TweenMax.set(this.$refs.right_slot,{duration:0.1,opacity:0,ease: "power4.inOut"});
                    tl.to(this.$refs.sotto_titolo_left,{duration:.4,bottom:"-4em",display:"none",ease: "power4.inOut"});
                    tl.to(this.$refs.sotto_titolo_right,{duration:.4,bottom:"-4em",display:"none",ease: "power4.inOut"},"-=.4"); 
                    //animazione resizing
                    /* tl.to(this.$refs.cnt_left,{ duration: 1.2,transformOrigin: "0% 0%",height:"0%", ease:"power4.inOut"}); */
                    tl.to(this.$refs.cnt_right,{ duration: 1.2,transformOrigin: "0% 0%",width:"0%", ease:"power4.inOut"});
                    tl.to(this.$refs.cnt_left,{duration:.7,width:"100%",ease: "power4.inOut"},"-=1.100552287");
                    tl.to(this.$refs.left_slot,{duration:.4,opacity:1,ease: "power4.inOut"});
                    tl.call(this.permetti)
                        break;


                    case "sx":
                        this.page = "center"; 
                        console.log(this.iterato);

                        //cambiare tutto questo con un TweenMax per problemi di click;
                        TweenMax.set(this.$refs.left_slot,{duration:0.1,opacity:0,ease: "power4.inOut"});


                        tl.to(this.$refs.cnt_left,{duration:.7,width:"50%",ease: "power4.inOut"});
                        tl.to(this.$refs.cnt_right,{ duration: 1.2,transformOrigin: "0% 0%",width:"50%", ease:"power4.inOut"},"-=1.100552287");
                        tl.to(this.$refs.sotto_titolo_left,{duration:.4,bottom:"1em",display:"block",ease: "power4.inOut"});
                        tl.to(this.$refs.sotto_titolo_right,{duration:.4,bottom:"1em",display:"block",ease: "power4.inOut"},"-=.4"); 
                        tl.to(this.$refs.cnt_right,{ duration: 1.2,transformOrigin: "0% 0%",height:"100%", ease:"power4.inOut"},"-=.4");
                        tl.call(this.permetti)


                        console.log("ha funzionato");

                        break;
                } 
            } 
        },
        vaiADestra(ev) {
            if(this.page == "dx" && ev.clientX > window.innerWidth/2) return;
            
            if(this.iterato==true) return;
            else{
            this.iterato=true;
            let tl=new TimelineMax({});
            switch(this.page) {
                case "center":
                    this.page = "dx"

                    //Da aggiustare il bug di left slot

                    TweenMax.set(this.$refs.right_slot,{duration:0.1,opacity:0,ease: "power4.inOut"});
                     tl.to(this.$refs.sotto_titolo_left,{duration:.4,bottom:"-4em",display:"none",ease: "power4.inOut"});
                    tl.to(this.$refs.sotto_titolo_right,{duration:.4,bottom:"-4em",display:"none",ease: "power4.inOut"},"-=.4"); 
                    //animazione resizing
                    /* tl.to(this.$refs.cnt_left,{ duration: 1.2,transformOrigin: "0% 0%",height:"0%", ease:"power4.inOut"}); */
                    tl.to(this.$refs.cnt_left,{ duration: 1.2,transformOrigin: "0% 0%",width:"0%", ease:"power4.inOut"});
                    tl.to(this.$refs.cnt_right,{duration:.7,width:"100%",ease: "power4.inOut"},"-=1.100552287");
                    tl.to(this.$refs.right_slot,{duration:.4,opacity:1,ease: "power4.inOut"});
                    tl.call(this.permetti)
                    break;
                case "dx":
                    this.page = "center"; 
                    //cambiare tutto questo con un TweenMax per problemi di click;
                    TweenMax.set(this.$refs.right_slot,{duration:0.1,opacity:0,ease: "power4.inOut"});


                    tl.to(this.$refs.cnt_right,{duration:.7,width:"50%",ease: "power4.inOut"});
                    tl.to(this.$refs.cnt_left,{ duration: 1.2,transformOrigin: "0% 0%",width:"50%", ease:"power4.inOut"},"-=1.100552287");
                    tl.to(this.$refs.sotto_titolo_left,{duration:.4,bottom:"1em",display:"block",ease: "power4.inOut"});
                    tl.to(this.$refs.sotto_titolo_right,{duration:.4,bottom:"1em",display:"block",ease: "power4.inOut"},"-=.4"); 
                    tl.to(this.$refs.cnt_left,{ duration: 1.2,transformOrigin: "0% 0%",height:"100%", ease:"power4.inOut"},"-=.4");

                    
                    tl.call(this.permetti)
                    


                    console.log("ha funzionato");

                    break;
                }     
            }
        },
        revealleft(){   
            let tl=new TimelineMax({});

            tl.to(this.$refs.sotto_titolo_left,{duration:.7,bottom:"0",ease: "power4.inOut"});

        }
    }
}
</script>

<style scoped>
.back-to-clock a {
    color: black;
    height:100%;
    text-decoration: none;
}
.back-to-clock {
    position: absolute;
    top: 0;
    width: 220px;
    text-align: center;
    left: calc(50% - 110px);
    padding: 10px 0px;
    font-size: 1.2em;
    color: black;
    background-color: white;
    cursor: pointer;
    transition-duration: .5s;
    border-radius: 0px 0px 30px 30px;

}
.hidden {
    top: -100px;
}
.underline {
    height: 5px;
    background-color: var(--secondary-color);
    width: 50px;
    margin-top: 12px;
    margin-bottom:7px;
    margin-left: 85px; 
    transition-duration: .5s;
}
.back-to-clock:hover .underline {
    width: 100px;
    margin-left: 60px;
}

.go-to-double {
    color: var(--primary-color);
    position: absolute;
    right: 50px;
    top: calc(50% - 2.5em / 2);
    font-size: 1.7em;
    height: 2.5em;
    display: flex;
    text-align: center;
}
.go-to-double:hover span {
    text-decoration: underline;
}
.go-to-double i {
    font-size: 1.3em;
}

.cnt_right .go-to-double {
    right: initial;
    left: 50px;
}

.cnt_complete{
    width: 100vw;
    height: 100vh;
    background-color: var(--background-color);
    display: flex;
}


.cnt_left{
    width: 50%;
    height: 100%;
    cursor:pointer;
    position: relative;
}

.cnt_right{
    width: 50%;
    height: 100%;
    cursor:pointer;
    position: relative;
}

.immagine{
    width:100%;
    height: 100%;
    background-position: center center;
    background-size: 100vw 100vh; 
    transition: 0.4s all;

}

.immagine_right{
    background-size: 100vw 100vh; 
    background-repeat: no-repeat;
    width:100%;
    height: 100%;
    background-position: center center;
    transition: 0.4s all;
}

.immagine:hover{
    background-size: 120vw 120vh; 
    transition: 0.4s all;
}

.immagine_right:hover {
    background-size: 120vw 120vh; 
    transition: 0.4s all;
}

.immagine_right:hover  .sotto_titolo{
    text-decoration: underline;
}

.immagine:hover  .sotto_titolo{
    text-decoration: underline;
}

.left_slot{
    opacity: 0;
    height: 100%;
}

.right_slot{
    opacity: 0;
    height: 100%;
}

/* Contenuto proveniente da base */
.cnt_text{
    background-color: var(--background-color);
    background: linear-gradient(to right, #000000 45.83%, rgba(255, 255, 255, 0) 100%);
    overflow-y: hidden;
    width: 100%;
    height: 100%;
}

.text{
    overflow-y: auto;
    height: 100%;
    width: 40%;
    margin:0% 5% 10% 5%;
    color: var(--primary-color);
    position: relative;
    line-height: 25px;
    word-spacing: 2.5px; 
}

.left_slot .text {
    transform: scaleX(-1);
    margin-left: 0;
}

.left_slot .text > div {
    transform: scaleX(-1);
    padding-left: 2.5vw;
}


.right_slot .text { 
    margin-right: 0;
}

.right_slot .text > div { 
    padding-right: 2.5vw;
}


.animation_text{
    position: relative;
    line-height: 30px;
    color:#D0D0D0;
}

.title{

    font-weight: bold;
    font-size: 50px;
    position: relative;
    margin-bottom: .6em;
    line-height: 60px;
    text-transform: capitalize;
}

#text_right{
    float: right;
    background: linear-gradient(to left, #000000 45.83%, rgba(255, 255, 255, 0) 100%);
}

.cnt_sotto_titolo{
    width: 70%;
    height: 40%;
    position: absolute;
    transform: translate(-50%,-50%);
    top: 40%;
    left: 50%;

    text-align: center;
    color: var(--primary-color);
    font-size: 50px;
    font-weight: bolder;
    color: var(--primary-color);
    text-transform: capitalize;
    overflow: hidden;
}

.sotto_titolo_relative{
    width: 100%;
    height: 100%;
    text-align: center;
}

.sotto_titolo{
    width: 100%;
    position: absolute;
    height: auto;
    bottom: 1em;
    text-align: center;
    box-shadow: inset 0 0 2000px rgb(0, 0, 0);

}
/* Immagine ma del contenuto */
.image{ 
    background-color: gray;
    width: 90%;
    height: 40vh;
    margin:10% 2.5% 10% 2.5%;
}

.underline_title{
   width: 30%;
   height: 10px;
   background-color: var(--secondary-color);
   margin-bottom: 12%;
}
.sotto_titolo {
    text-transform: capitalize;
}
</style>